import httpService from '@Utils/httpService';

const baseUrl = 'api/inspectiondashboard';
export default {
    getUnits(assetId) {
        return httpService.get({
            url: `${baseUrl}/units/${assetId}`
        });
    },

    getFrbiCount(params) {
        return httpService.post({
            url: `${baseUrl}/adnoc/frbi/summary`,
            data:params
        });
    },
    getDfCount( params) {
        return httpService.post({
            url: `${baseUrl}/adnoc/df/summary`,
            data:params
        });
    },
    getIowCount(params) {
        return httpService.post({
            url: `${baseUrl}/adnoc/iow/summary`,
            data:params
        });
    },
    getRiskMatrix(params) {
        return httpService.post({
            url: `${baseUrl}/adnoc/risk-matrix`,
            data:params
        });
    },
 
};

